import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, vShow as _vShow, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  style: {"min-width":"400px","width":"40vw","margin":"auto","margin-top":"100px"},
  class: "border-box"
}
const _hoisted_2 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  style: {"margin-top":"25px","font-size":"16px"}
}
const _hoisted_7 = { style: {"margin-top":"8px"} }

import { ref, computed, onMounted, watch } from 'vue'
    import { useRouter } from 'vue-router'

    import ValidationError from '@common/Components/ValidationError.vue'
    import { useCurrentUserQueryV1, usePasswordPolicyQueryV1 } from '@Organizations/Users/queries-vue-composables'
    import { useChangePasswordCommandV1 } from '@Organizations/Users/commands-vue-composables'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ChangePasswordPage',
  setup(__props) {

    const router = useRouter()

    const password = ref('')
    const passwordConfirmation = ref('')

    const { runCurrentUserQueryV1,
        modelCurrentUserQueryV1: userSessionDetails } = useCurrentUserQueryV1()

    const { runPasswordPolicyQueryV1,
        modelPasswordPolicyQueryV1: passwordPolicy } = usePasswordPolicyQueryV1()

    const userId = computed(() => userSessionDetails.value?.UserId)

    const passwordConfirmed = computed(() => password.value === passwordConfirmation.value)
    const isValid = computed(() =>!!password.value && passwordConfirmed.value)

    const {
        invokeChangePasswordCommandV1,
        validationErrors,
        errorChangePasswordCommandV1,
        succeedChangePasswordCommandV1
    } = useChangePasswordCommandV1(userId, password)

    watch(succeedChangePasswordCommandV1, (succeeded) =>
    {
        if (succeeded)
        {
            router.push('/')
        }
    })

    onMounted(() =>
    {
        document.title = 'Change password'
        runCurrentUserQueryV1();
        runPasswordPolicyQueryV1()
    })

    function handleChangePasswordCommandV1()
    {
        if (!isValid.value || !userId.value) return

        if (errorChangePasswordCommandV1.value)
        {
            errorChangePasswordCommandV1.value = null
        }

        invokeChangePasswordCommandV1()
    }

    function goBack()
    {
        router.back()
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      onClick: goBack,
      type: "button",
      class: "btn btn-lg btn-link"
    }, [...(_cache[2] || (_cache[2] = [
      _createElementVNode("i", {
        class: "fa fa-arrow-left",
        "aria-hidden": "true"
      }, null, -1 /* CACHED */),
      _createTextVNode(" Back ", -1 /* CACHED */)
    ]))]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "fg-color-blue" }, "Change your password", -1 /* CACHED */)),
        _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1 /* CACHED */)),
        (_unref(errorChangePasswordCommandV1))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(errorChangePasswordCommandV1)), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("label", { for: "Password" }, "New password:", -1 /* CACHED */)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
            type: "password",
            class: "form-control"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, password.value]
          ]),
          _createVNode(ValidationError, {
            context: "Password",
            errors: _unref(validationErrors)
          }, null, 8 /* PROPS */, ["errors"])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("label", { for: "PasswordConfirmation" }, "New password confirmation:", -1 /* CACHED */)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((passwordConfirmation).value = $event)),
            type: "password",
            class: "form-control"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, passwordConfirmation.value]
          ])
        ], 512 /* NEED_PATCH */), [
          [_vShow, password.value]
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1 /* CACHED */)),
        _createElementVNode("button", {
          onClick: handleChangePasswordCommandV1,
          type: "button",
          class: "btn btn-primary btn-lg btn-block",
          disabled: !isValid.value
        }, "Change password", 8 /* PROPS */, _hoisted_5)
      ]),
      (_unref(passwordPolicy))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[8] || (_cache[8] = _createElementVNode("strong", null, "Password validation requirements:", -1 /* CACHED */)),
            _createElementVNode("ul", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(passwordPolicy).Rules, (rule) => {
                return (_openBlock(), _createElementBlock("li", null, _toDisplayString(rule), 1 /* TEXT */))
              }), 256 /* UNKEYED_FRAGMENT */))
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

})